export default {
  computed: {
    isMobileOrTablet() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isDesktop() {
      return !this.isMobileOrTablet;
    },
    orientation() {
      return this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width ? 'portrait' : 'landscape';
    },
  },
};
